// 文字打印默认值
export const DefaultTextConfigEnum = {
  FONT_SIZE: 10,
  COLOR: '#000',
  FONT_FAMILY: 'Microsoft YaHei',
  LETTER_SPACEING:  0,
  POSITION_X:  0,
  POSITION_Y:  0
}

// 打印内容字段对应内容
export const printLabelMap = {
  'GOODS': {
    'title': '',
    'titlePrint': '',
    'fnsku': '',
    'msku': '',
    'sku': '',
    '-1': 'Made in China',
    '-2': 'NEW',
    'productName': ''
  },
  'PRODUCT': {
    'name': '',
    'sku': '',
    'namePrint': '',
    'categoryName': '',
    'brandName': '',
    '-1': 'Made in China',
    '-2': 'NEW',
  }
}

// 商品/产品数据可编辑字段
export const editPrintLabelMap = {
  'GOODS': {
    fnsku: 'fnsku',
    titlePrint: 'title'
  },
  'PRODUCT': {
    namePrint: 'skuName'
  }
}

// 商品打印内容
export const goodsprintLabelList = [
  {id: 'title', text: '商品标题', type: 'text', x: 0, y: 0, size: 10, spacing: 0, selected: false },
  {id: 'titlePrint', text: '商品标题(打印)', type: 'text', x: 0, y: 0, size: 10, spacing: 0, selected: false },
  {id: 'fnsku', text: 'FNSKU', type: 'text', x: 0, y: 0, size: 10, spacing: 0, selected: false },
  {id: 'msku', text: 'MSKU', type: 'text', x: 0, y: 0, size: 10, spacing: 0, selected: false },
  {id: 'sku', text: 'SKU', type: 'text', x: 0, y: 0, size: 10, spacing: 0, selected: false },
  {id: '-1', text: 'Made in China', type: 'text', x: 0, y: 0, size: 10, spacing: 0, selected: false },
  {id: '-2', text: 'NEW', type: 'text', x: 0, y: 0, size: 10, spacing: 0, selected: false },
  {id: 'productName', text: '产品名称', type: 'text', x: 0, y: 0, size: 10, spacing: 0, selected: false },{id: 'barcode', text: '条形码', type: 'barcode', x: 0, y: 0, selected: true }
]

// 产品打印内容
export const productPrintLabelList = [
  {id: 'name', text: '产品名称', type: 'text', x: 0, y: 0, size: 10, spacing: 0, selected: false },
  {id: 'sku', text: 'SKU', type: 'text', x: 0, y: 0, size: 10, spacing: 0, selected: false },
  {id: 'namePrint', text: '打印产品名称', type: 'text', x: 0, y: 0, size: 10, spacing: 0, selected: false },
  {id: 'categoryName', text: '品类', type: 'text', x: 0, y: 0, size: 10, spacing: 0, selected: false },
  {id: '-2', text: 'NEW', type: 'text', x: 0, y: 0, size: 10, spacing: 0, selected: false },
  {id: '-1', text: 'Made in China', type: 'text', x: 0, y: 15, size: 10, spacing: 0, selected: false },
  {id: 'brandName', text: '品牌', type: 'text', x: 0, y: 0, size: 10, spacing: 0, selected: false },
  {id: 'barcode', text: '条形码', type: 'barcode', x: 0, y: 0, selected: true }
]